import styled from "styled-components";
import { Icon, KeyButton } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const IconStyled = styled(Icon)`
  width: ${props => props.iconWidth || props.theme.components.selector.icon.size};
  height: ${props => props.iconHeight || props.theme.components.selector.icon.size};
  fill: ${props => props.theme.color.white};
`;

export const ImageDefaultStyled = styled.img`
  max-width: 100%;
  height: auto;
  position: absolute;
`;
export const PageWrapper = styled.div`
  display: flex;
  ${props => (props.direction === "rtl" ? "margin-right:" : " margin-left:")} 16%;
  padding-top: 3.51rem;
  position: relative;
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}:4.6rem`};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  width: 67.5rem;
  text-align: center;
  margin-top: ${props => props.theme.spacing.xxsmall};
`;

export const MainHeading = styled.h3`
  color: ${props => props.theme.color.white};
  font-size: ${props => props.theme.font.size.large};
  font-weight: ${props => props.theme.font.weight.semiBold};
  margin-bottom: ${props => props.theme.spacing.xxsmall};
  text-align: center;
`;

export const HeadingText = styled.p`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.small};
  text-align: center;
  margin-bottom: ${props => props.theme.spacing.xmedium};
`;
export const ErrorHeadingText = styled.p`
  color: ${props => props.theme.color.error};
  font-size: ${props => props.theme.font.size.default};
  text-align: center;
  margin-bottom: 0.83rem;
`;

export const MainViewContainer = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  margin-bottom : 0.83rem;

  article {
   width: 29.8rem !important;
  }
   
//  button:not(.focused) {
//    background-color: #003E43 !important;
//  }
  article button {
    height : 4.5rem;
    width : 9.375rem;
    border-radius: 0.42rem;
    font-size: 2.08rem;
    margin:0.21rem;
   
  }

  article button:last-child {
    width 19.17rem;
  }

  article button svg {
    width: 5vw;
    height: 3vw;
    margin-bottom: 0.42rem;
  }
`;

export const InputFieldContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.xmedium};
  ${props => (props.direction === "rtl" ? "margin-left:" : " margin-right:")} 0.42rem;
`;

export const InputDigit = styled.input`
  height: 4.5rem;
  width: 5.625rem;
  font-size: 2.08rem;
  text-align: center;
  color: ${props => props.theme.color.white};
  background: none;
  border: none;
  margin-left: 0.42rem;
  margin-right: 0.42rem;

  ::-webkit-input-placeholder {
    color: ${props => props.theme.color.greyLight};
    font-size: 5.83rem;
  }
`;

export const ButtonsGroupStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.83rem;
  font-size: 1.67rem;
`;

export const KeyButtonStyledCancel = styled(KeyButton)`
  width: 14.32rem;
  height: 4.5rem;
  border: none;
  margin-left: 0.208rem;
  font-size: 1.67rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  margin-right: 0.208rem;
  &.focused {
    font-weight: ${props => props.theme.font.weight.bold};
  }
  // :not(.focused) {
  //   background-color: #003e43 !important;
  // }
`;

export const KeyButtonStyledContinue = styled(KeyButtonStyledCancel)`
  width: 14.32rem;
  height: 4.5rem;
  border: none;
  margin-left: 0.208rem;
  font-size: 1.67rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  margin-right: 0.208rem;
  ${props => props.disabled && `opacity: 0.6`};
  &.focused {
    font-weight: ${props => props.theme.font.weight.bold};
  }
  // :not(.focused) {
  //   background-color: #003e43 !important;
  // }
`;

export const FooterStyled = styled.div`
  height: 2.4rem;
  width: 22.5rem;
  color: ${props => props.theme.color.white};
  font-size: 0.9375rem;
  line-height: 1.198rem;
  display: flex;
  ${props => (props.direction === "rtl" ? "margin-right:" : " margin-left:")} 34%;
  margin-top: 0.83rem;
`;
